export default {"src":"/apac/_next/static/media/delete.09968504.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};